import { render } from "./Content_news.vue?vue&type=template&id=da12f0ac&scoped=true"
import script from "./Content_news.vue?vue&type=script&lang=js"
export * from "./Content_news.vue?vue&type=script&lang=js"

import "./Content_news.vue?vue&type=style&index=0&id=da12f0ac&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da12f0ac"]])